import { ENUM_DOCUMENT_TYPE } from "@entities/documents";
import { ENUM_INVOICE_TYPE } from "../types";

export const INVOICE_STATUS: Record<ENUM_INVOICE_TYPE, ENUM_DOCUMENT_TYPE> = {
  [ENUM_INVOICE_TYPE.INVOICE]: ENUM_DOCUMENT_TYPE.INVOICE_NO_ACT,
  [ENUM_INVOICE_TYPE.ACT]: ENUM_DOCUMENT_TYPE.WORK_ACT,
};
